/** Keep one trailing separator while typing so the next identifier does not join the previous one. */
export function formatBulkIdentifiers(value: string, event?: {type?: string}): string {
    const formatted = value.replace(/[\s,.;:]+/g, ' ').replace(/^ +/, '');
    return event?.type === 'blur' ? formatted.trimEnd() : formatted;
}
